import { APP_INITIALIZER, LOCALE_ID } from '@angular/core';
import { I18NextModule, I18NextService } from 'angular-i18next';
import * as flatpickr from 'flatpickr';
import { Russian as FlatpickrRu } from 'flatpickr/dist/l10n/ru';
import I18NextXhrBackend from 'i18next-xhr-backend';
import { CookieService } from 'ngx-cookie';

declare let alertify: any;

const i18nextOptions = {
    backend: {
        loadPath: () => `/dist/locales/{{ns}}.{{lng}}.json?v=${ETR.applicationVersion}`
    },
    debug: false,
    fallbackLng: 'ru',
    interpolation: {
        format: I18NextModule.interpolationFormat()
    },
    ns: ['shared'],
    whitelist: ['ru', 'en']
};

class LanguageDetector {
    public type: string = 'languageDetector';

    constructor(private cookieService: CookieService) {}

    public init(): void {
        return;
    }

    public detect(): string {
        const lang = this.cookieService.get('lcid') || '1049';
        return lang === '1049' ? 'ru' : 'en';
    }

    public cacheUserLanguage(lang: string): void {
        let cookieDomain;
        switch (window.location.hostname) {
            case 'requests-s7.eastbanctech.ru':
                cookieDomain = '.eastbanctech.ru';
                break;
            case 'requests.s7.ru':
            case 'requests-test01.s7.ru':
                cookieDomain = '.s7.ru';
                break;
            default:
                cookieDomain = undefined;
        }
        this.cookieService.put('lcid', lang === 'ru' ? '1049' : '1033', {
            domain: cookieDomain,
            path: '/'
        });
    }
}

export function appFactory(i18NextService: I18NextService, cookieService: CookieService): () => Promise<any> {
    return () => i18NextService
            .use(I18NextXhrBackend)
            .use(<any>new LanguageDetector(cookieService))
            .init(i18nextOptions)
            .then(() => {
                alertify.set({
                    labels: {
                        cancel: i18NextService.t('shared:labels.cancel'),
                        ok: i18NextService.t('shared:labels.ok')
                    }
                });
                if (i18NextService.language === 'ru') {
                    FlatpickrRu.rangeSeparator = ' по ';
                    const flatpickrInstance = (function(): any {
                        return flatpickr;
                    })();
                    flatpickrInstance.localize(FlatpickrRu);
                }
            });
}

export function localeFactory(i18next: I18NextService): string {
    return i18next.language;
}

export const I18N_PROVIDERS = [
    {
        deps: [I18NextService, CookieService],
        multi: true,
        provide: APP_INITIALIZER,
        useFactory: appFactory
    },
    {
        deps: [I18NextService],
        provide: LOCALE_ID,
        useFactory: localeFactory
    }
];
